var _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02653 18.6042L5.77148 10.9948L13.3809 10.7397L13.636 18.3492L6.02653 18.6042ZM6.45205 11.6317L6.66316 17.9233L12.9548 17.7122L12.7436 11.4206L6.45205 11.6317Z",
    fill: "#1C273B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.738 11.1445C23.738 12.4667 22.6659 13.5391 21.3434 13.5391C20.0213 13.5391 18.9492 12.467 18.9492 11.1445C18.9492 9.82239 20.0213 8.75 21.3434 8.75C22.6659 8.75033 23.738 9.82239 23.738 11.1445Z",
    fill: "#1BA904"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.199 10.0172L63.0664 10.5259L68.1212 11.8432L68.2538 11.3346L63.199 10.0172Z",
    fill: "#1C273B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0641 8.3419L64.7461 13.3965L65.2547 13.5291L66.5727 8.47451L66.0641 8.3419Z",
    fill: "#1C273B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 49,
    r: 36,
    fill: "#9FD6CA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 46,
    r: 36,
    stroke: "#1C273B",
    strokeWidth: 0.528595,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72 27.9999C69.2342 29.0587 66.5581 30.3508 64.0058 31.8531C54.9183 37.2013 47.8964 44.9508 43.395 54.4572C41.5643 58.3234 39.8742 62.332 38.2181 66.2267C37.7593 67.3058 36.8089 68.4878 35.8207 67.1334C34.2298 64.9517 32.797 62.6337 31.2915 60.3929C28.5278 56.2802 25.7636 52.1676 23 48.055L27.9793 47.8836L32.439 47.7303L36.4027 53.6288C37.2338 51.8063 38.3424 49.6985 39.8113 47.4763C41.7778 44.5002 44.3909 41.3205 47.8482 38.3472C57.4733 30.0694 67.889 28.3448 71.8976 27.8899C71.9316 27.9266 71.9661 27.9633 72 27.9999Z",
    fill: "#F9FAFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74 25.9999C71.2342 27.0587 68.5581 28.3508 66.0058 29.8531C56.9183 35.2013 49.8964 42.9508 45.395 52.4572C43.5643 56.3234 41.8742 60.332 40.2181 64.2267C39.7593 65.3058 38.8089 66.4878 37.8207 65.1334C36.2298 62.9517 34.797 60.6337 33.2915 58.3929C30.5278 54.2802 27.7636 50.1676 25 46.055L29.9793 45.8836L34.439 45.7303L38.4027 51.6288C39.2338 49.8063 40.3424 47.6985 41.8113 45.4763C43.7778 42.5002 46.3909 39.3205 49.8482 36.3472C59.4733 28.0694 69.889 26.3448 73.8976 25.8899C73.9316 25.9266 73.9661 25.9633 74 25.9999Z",
    stroke: "#1C273B",
    strokeWidth: 0.528595,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.aa46500b7f6b883af0f1b1e9c88d898e.svg";
export { ForwardRef as ReactComponent };